import Indicators, { Rating, Type as IndicatorsType } from '@solucx/indicators';

export class ClassRatingLike {
  public static getRatingLike(score: number, indicatorType: IndicatorsType): boolean {
    const rate: Rating = Indicators.getIndicator(indicatorType).getRating(score);

    const ratingLike = {
      [Rating.POSITIVE]: true,
      [Rating.NEGATIVE]: false,
      [Rating.NEUTRAL]: null,
      [Rating.NONE]: null,
    };

    return ratingLike[rate];
  }
}
